import React, { FC } from 'react';
import { Tabs } from 'components';
import CampaignParams from './components/CampaignParams';

import './Settings.styles.scss';

const Settings: FC = () => {
  return (
    <Tabs
      className="settings"
      items={[{ label: 'Campaigns', element: <CampaignParams /> }]}
    />
  );
};

export default Settings;
